//#region src/side_nav_image_size.ts
let SideNavImageSize = /* @__PURE__ */ function(SideNavImageSize) {
	SideNavImageSize["Small"] = "small";
	SideNavImageSize["Medium"] = "medium";
	SideNavImageSize["Large"] = "large";
	return SideNavImageSize;
}({});
//#endregion
export { SideNavImageSize };

//# sourceMappingURL=side_nav_image_size.js.map